import { makeStyles } from "@mui/styles";
import React from "react";
import { MobileWeb } from "./BreakPoint";
import { Theme } from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 824,
    width: "100%",
    backgroundColor: "#C4C4E6",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",

    [theme.breakpoints.up(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  items1: {
    display: "inline",
    fontSize: 12,
    marginRight: 20,
    color: "white",
  },
  items2: {
    display: "inline",
    fontSize: 12,
    textAlign: "right",
    color: "white",
  },
}));

export const MobileFooter = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.items1}>
        <span style={{ padding: "5px 0px", display: "block" }}>
          (주)휴먼브릿지
        </span>

        <span style={{ padding: "5px 0px", display: "block" }}>
          대표자: 임지영
        </span>

        <span style={{ padding: "5px 0px", display: "block" }}>
          인천광역시 미추홀구
          <br /> 인하로 100, 5남 369호
        </span>
      </div>
      <div className={classes.items2}>
        {/* <span style={{ padding: "5px 0px", display: "block" }}>
          고객센터: 032-000-0000
        </span> */}

        <span style={{ padding: "5px 0px", display: "block" }}>
          개인정보처리방침
        </span>

        <span style={{ padding: "5px 0px", display: "block" }}>
          Copyright &copy; 2021
          <br /> (주)휴먼브릿지
          <br /> All rights reserved
        </span>
      </div>
    </div>
  );
};
